module.exports = __webpack_public_path__ + "static/media/icono grande 80porc.a6f34bec.png";